import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "plan-content p-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "sm-fs-base" }, "Download ", -1)
const _hoisted_6 = { class: "bordered-card bordered-card_secondary w-100 overflow-auto" }
const _hoisted_7 = { class: "small mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Date/Time Requested"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("For Coverage "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Year")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("# of Employees "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" in Req")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "Requestor"),
    /*#__PURE__*/_createElementVNode("th", null, "File Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Download As")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-break" }
const _hoisted_11 = { class: "text-break" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    class: "text-center"
  }, " No Available Requests")
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "action-buttons pdt-100 sm-mb-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { error: _ctx.error }, null, 8, ["error"]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _hoisted_8,
          (_ctx.requests?.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requests, (request) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: request.RequestID
                  }, [
                    _createElementVNode("td", null, _toDisplayString(request.Date), 1),
                    _createElementVNode("td", null, _toDisplayString(request.Year), 1),
                    _createElementVNode("td", null, _toDisplayString(request.EmployeesNumber), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(request.Requestor), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(request.FileName), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("i", {
                        class: "iatse-icon-csv fs-xxl mr-10 plan-modal",
                        onClick: ($event: any) => (_ctx.handleDownload(request, 'xlsx'))
                      }, null, 8, _hoisted_12),
                      _createElementVNode("i", {
                        class: "iatse-icon-pdf-file fs-xxl plan-modal",
                        onClick: ($event: any) => (_ctx.handleDownload(request, 'pdf'))
                      }, null, 8, _hoisted_13)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_14, _hoisted_16))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
      }, " Back to Home ")
    ])
  ], 64))
}